import React from "react";

export const SectionHeader = ({
  eyebrow,
  title,
  description,
  align = "left",
  testid,
}) => {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignClass} mb-12`} data-testid={testid}>
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-600 mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-slate-900">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export const PageHero = ({ eyebrow, title, description, testid }) => (
  <section
    className="relative overflow-hidden border-b border-slate-100"
    data-testid={testid}
  >
    <div className="absolute inset-0 pointer-events-none">
      <div
        className="absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full blur-3xl opacity-20 animate-blob"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, #6366f1, transparent 60%)",
        }}
      />
      <div
        className="absolute -bottom-20 -left-10 w-[380px] h-[380px] rounded-full blur-3xl opacity-15 animate-blob"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, #ec4899, transparent 60%)",
          animationDelay: "3s",
        }}
      />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-indigo-600 mb-4">
          {eyebrow}
        </p>
      )}
      <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold uppercase tracking-tight text-slate-900 max-w-4xl">
        {title}
      </h1>
      {description && (
        <p className="mt-6 text-lg text-slate-600 max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
    </div>
  </section>
);

export default SectionHeader;
